// Footer shared by the Add/Edit Unit dialog and the Contacts tab's link
// dialogs: pending-change summary (or "Saved" / per-item errors) on the
// left, Cancel/Close and Save on the right.

import React from "react";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const LinkDialogFooter = ({ statusText, savedFlash, errors, dirty, saving, saveLabel = "Save", onCancel, onSave }) => (
	<div className="linkDialogFooter">
		<div className={`linkDialogStatus${errors.length ? " hasErrors" : ""}`}>
			{errors.length > 0 ? (
				errors.map((e) => <div key={e}>{e}</div>)
			) : (
				<>
					{savedFlash && <CheckCircleIcon className="linkDialogSavedIcon" />}
					{statusText}
				</>
			)}
		</div>
		<Button variant="outlined" color="primary" onClick={onCancel} disabled={saving}>
			{dirty ? "Cancel" : "Close"}
		</Button>
		<Button
			variant="contained"
			color="primary"
			disableElevation
			onClick={onSave}
			disabled={saving || !dirty}
			startIcon={saving ? <CircularProgress size={14} color="inherit" /> : null}
		>
			{saving ? "Saving…" : saveLabel}
		</Button>
	</div>
);

export default LinkDialogFooter;
